<template>
  <div class="room pt-3 room_consumes">
    <div v-if="typeof room_data !== 'undefined'">
      <b-container class="mt-3">
        <b-row>
          <b-col cols="12" class="text-center">
            <h4 class="m-0 color-green font-weight-bold">{{room_data.room.room_number}}</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <table class="table text-center table-striped">
              <thead class="bg-grey-dark text-white">
                <tr>
                  <th class="text-left" scope="col">{{trans['ARTIGO']}}</th>
                  <th class="text-center" scope="col">{{trans['QTD']}}</th>
                  <th v-if="!checkAIRegime(room_data)" class="text-center" scope="col">{{trans['CONSUMO']}}</th>
                  <th v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == false || checkAIRegime(room_data)" class="text-center" scope="col">{{trans['QUEBRA']}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in hk_item_prices_tmp" :key="idx" class="text-left">
                  <td scope="row" class="text-left align-middle">{{item.name}}</td>
                  <td scope="row" class="text-center align-middle">{{item.quantity}}</td>

                  <!-- DESKTOP DISPLAY -->
                  <td scope="row" class="text-center d-none d-sm-table-cell align-middle" v-if="!checkAIRegime(room_data)">
                    <b-button
                      v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true"
                      v-on:click="update_consumes(item, -1)"
                      class="no-border bg-green-light"
                    >
                        <b class="fa fa-minus"></b>
                    </b-button>
                    <b class="pl-3 pr-3">{{item.consumed}}</b>
                    <b-button
                      v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true"
                      v-on:click="update_consumes(item, 1)"
                      class="no-border bg-green-light"
                    >
                      <b class="fa fa-plus"></b>
                    </b-button>
                  </td>
                  <td v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == false || checkAIRegime(room_data)" scope="row" class="text-center d-none d-sm-table-cell align-middle">
                    <b-button
                      v-if="room_data.breaking_closed != 1"
                      v-on:click="update_breaking(item, -1)"
                      class="no-border bg-green-light">
                        <b class="fa fa-minus"></b>
                    </b-button>
                    <b class="pl-3 pr-3">{{item.breaking}}</b>
                    <b-button
                      v-if="room_data.breaking_closed != 1"
                      v-on:click="update_breaking(item, 1)"
                      class="no-border bg-green-light">
                        <b class="fa fa-plus"></b>
                    </b-button>
                  </td>

                  <!-- MOBILE DISPLAY -->
                  <td scope="row" class="text-center d-table-cell d-sm-none align-middle" v-if="!checkAIRegime(room_data)">
                    <b-button
                      v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true"
                      v-on:click="update_consumes(item, 1)"
                      class="no-border bg-green-light"
                    >
                      <b class="fa fa-plus"></b>
                    </b-button>
                    <br v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true">
                    <b class="pl-3 pr-3">{{item.consumed}}</b>
                    <br v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true">
                    <b-button
                      v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == true"
                      v-on:click="update_consumes(item, -1)"
                      class="no-border bg-green-light"
                    >
                      <b class="fa fa-minus"></b>
                    </b-button>
                  </td>
                  <td v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == false || checkAIRegime(room_data)" scope="row" class="text-center d-table-cell d-sm-none align-middle">
                      <b-button
                        v-if="room_data.breaking_closed != 1"
                        v-on:click="update_breaking(item, 1)"
                        class="no-border bg-green-light">
                          <b class="fa fa-plus"></b>
                      </b-button>
                      <br v-if="room_data.breaking_closed != 1">
                      <b class="pl-3 pr-3">{{item.breaking}}</b>
                      <br v-if="room_data.breaking_closed != 1">
                      <b-button
                        v-if="room_data.breaking_closed != 1"
                        v-on:click="update_breaking(item, -1)"
                        class="no-border bg-green-light">
                          <b class="fa fa-minus"></b>
                      </b-button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="row" class="text-left">{{trans['TOTAL']}}</th>
                  <th scope="row" class="text-center">{{total_items}}</th>
                  <th v-if="!checkAIRegime(room_data)" scope="row" class="text-center">{{total_items_consumed}}</th>
                  <th v-if="['4', '5'].includes(room_data.reservation_check_out.cod_status) == false || checkAIRegime(room_data)" scope="row" class="text-center">{{total_items_breaking}}</th>
                </tr>
              </tfoot>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-3 mb-4">
          <div>
            <div>
              <label for="inp-observation">{{trans['OBSERVACOES']}}</label>
              <b-form-textarea
                  id="inp-observation"
                  v-model="observation"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
            </div>
          </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
    <!-- {{room_data}} -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'room_clothes',
  props: ['room'],
  data() {
    return {
      loading           : false,
      hk_item_prices_tmp: null,
      observation       : null,
    }
  },
  methods: {
    validate_quantity: function (item, val, next_val) {
      let total_next_val = parseInt(item.consumed) + parseInt(item.breaking) + val;
      if((next_val < 0) || total_next_val > item.quantity) {
          return false;
      }
      return true;
    },
    update_item: function (item, type) {
      var frase = type == 'breaking' ? this.trans['EXISTEM_ALTERACOES_NAS_QUEBRAS'] : this.trans['EXISTEM_ALTERACOES_NOS_CONSUMOS'];
      var btn_text = type == 'breaking' ? this.trans['AVANCAR'] : this.trans['DEBITAR'];
      item.changed  = 1;
      this.$emit('show_consumes_alert');
      this.$emit('set_modal_info', {title: 'Aviso', body: frase +'<br> '+this.trans['PRETENDE_AVANCAR'], has_btns: true, btn_text: btn_text});
    },
    update_consumes: function(item, val) {
      let next_val = parseInt(item.consumed) + val;
      if(!this.validate_quantity(item, val, next_val)) {
        return;
      }
      item.consumed = next_val;
      this.update_item(item, 'consumes');
    },
    update_breaking: function(item, val) {
      let next_val = parseInt(item.breaking) + val;
      if(!this.validate_quantity(item, val, next_val)) {
        return;
      }
      item.breaking = next_val;
      this.update_item(item, 'breaking');
    },
    save: function(save) {

      // Check if internet is available, go back and warn if no internet
      if (navigator && !navigator.onLine) {

        this.$emit('go_to', {
                  name  : 'list_rooms',
                  params: {
                      cod_dist_zone: this.room_data.cod_distribution_zone,
                      elem_scroll  : "room_" + this.room_data.room.room_number,
                      search_hotel: this.$distribution.search_hotel,
                      search_bloco: this.$distribution.search_bloco,
                      search_piso: this.$distribution.search_piso,
                      search_n_quarto: this.$distribution.search_n_quarto
                  }
              });

        setTimeout(() => {
          this.$bvToast.toast(this.trans['BREAKING_NOT_SAVED_NO_INTERNET'], { title: 'Erro', variant: 'danger', solid: true });
        }, "1000");

        return;
      }

      if(save) {
        const that = this;
        this.$emit('set_loading', true);
        this.room_data.room.espaco.hk_item_prices = JSON.parse(JSON.stringify(this.hk_item_prices_tmp));
        for(let item of this.room_data.room.espaco.hk_item_prices) {
          let consume_idx = this.room_data.consumes.map((cItem, i) => item.cod_items_price == cItem.cod_items_price ? i : -1).filter(index => index !== -1);
          if (consume_idx.length > 0) {
            consume_idx.forEach(function (cIndex, idx) {
              that.room_data.consumes[cIndex].quantity = 0;
            });
            this.room_data.consumes[consume_idx[0]].quantity = item.consumed;
            if (item.changed && item.changed == 1) {
              this.room_data.saved          = 0;
              this.room_data.saved_consumes = 0;
            }
          }
          let breaking_idx = this.room_data.breakings.findIndex((i, idx) => item.cod_items === i.item_id);
          this.room_data.breakings[breaking_idx].quantity = item.breaking;
          if (item.changed && item.changed == 1) {
            this.room_data.saved          = 0;
            this.room_data.saved_consumes = 0;
          }
        }
        if (this.room_data.observation != this.observation) {
          this.room_data.saved = 0;
        }
        this.room_data.observation = this.observation;

        this.$emit('go_to', {
          name: 'list_rooms',
          params: {
            cod_dist_zone: this.room_data.cod_distribution_zone,
            elem_scroll: "room_" + this.room_data.room.room_number,
            search_hotel: this.$distribution.search_hotel,
            search_bloco: this.$distribution.search_bloco,
            search_piso: this.$distribution.search_piso,
            search_n_quarto: this.$distribution.search_n_quarto
          }
        });
      }
      else {
        this.hk_item_prices_tmp = JSON.parse(JSON.stringify(this.room_data.room.espaco.hk_item_prices));
      }
    },
    send_data: function(items) {
      if(items.length > 0) {
        this.$http.post('housekeeping/update_rooms?token=' +this.$distribution.person.token,
          {
            rooms: items
          },
          {
            before(request) {
              this.loading = true;
            }
          }
        )
        .then(resp => {
          for(var r of resp.body.rooms) {
                  for(var z of this.$distribution.zones) {
                    var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == r.cod_distribution_room);
                    if(r_idx !== -1) {
                      this.$set(z.rooms, r_idx, r);
                    }
                  }
              }
        }, resp => {

        }).then(resp => {
          this.$emit('go_to', {name: 'list_rooms', params: {cod_dist_zone: this.room_data.cod_distribution_zone,
                                                            search_hotel: this.$distribution.search_hotel,
                                                            search_bloco: this.$distribution.search_bloco,
                                                            search_piso: this.$distribution.search_piso,
                                                            search_n_quarto: this.$distribution.search_n_quarto}});
          this.loading = false;
        });
      }
    },
    checkAIRegime(room_data){
      if(room_data.room &&
      room_data.room.precos &&
      room_data.room.precos[0] &&
      room_data.room.precos[0].pos_regime) {
        return (room_data.room.precos[0].pos_regime.cod_regime == 5) ? true : false;
      }
      return false;
    }
  },
  computed: {
    room_data: function() {
      let zone = this.get_zone();
      if(typeof zone !== 'undefined') {
        let room = this.get_room(zone);
        if(typeof room !== 'undefined') {
          return room;
        }
      }
      if(typeof this.room !== 'undefined') { // check if we can use prop sent by router link
          return this.room;
      }
    },
    total_items: function() {
      return this.room_data.room.espaco.hk_item_prices.reduce((current_sum, item) => current_sum + parseInt(item.quantity), 0);
    },
    total_items_consumed: function() {
      return this.hk_item_prices_tmp.reduce((current_sum, item) => current_sum + parseInt(item.consumed), 0);
    },
    total_items_breaking: function() {
      return this.hk_item_prices_tmp.reduce((current_sum, item) => current_sum + parseInt(item.breaking), 0);
    }
  },
  watch: {
  },
  created: function() {
    const that = this;
    if(typeof this.room_data === 'undefined') {
      this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
      return;
    }

    this.room_data.breaking_closed = 0;
    for(var c of this.room_data.room.espaco.hk_item_prices) {
      c.changed  = 0;
      c.consumed = 0;
      c.breaking = 0;
      c.cod_client_account_items = [];
      let hip_tmp = this.room_data.consumes.map((item, i) => item.cod_items_price == c.cod_items_price ? i : -1).filter(index => index !== -1);
      if (hip_tmp.length > 0) {
        hip_tmp.forEach(function (cIndex, idx) {
          c.consumed += parseInt(that.room_data.consumes[cIndex].quantity, 10);
          c.cod_client_account_items.push(that.room_data.consumes[cIndex].cod_client_account_items);
          that.room_data.consumes[cIndex].cod_items = c.cod_items;
          that.room_data.consumes[cIndex].cod_client_account = that.room_data.reservation_check_out.main_client_account.cod_client_account;
        });
      } else {
        this.room_data.consumes.push({
          quantity                : 0,
          cod_items_price         : c.cod_items_price,
          cod_distribution_room   : this.room_data.cod_distribution_room,
          cod_items               : c.cod_items,
          cod_client_account      : this.room_data.reservation_check_out.main_client_account.cod_client_account,
          cod_client_account_items: null
        });
      }

      let break_tmp = this.room_data.breakings.findIndex((item, idx) => item.item_id == c.cod_items);
      if(break_tmp !== -1) {
          c.breaking        = this.room_data.breakings[break_tmp].quantity;
          this.room_data.breakings[break_tmp].cod_items_price = c.cod_items_price;
          if (this.room_data.breakings[break_tmp].closed_at) {
            this.room_data.breaking_closed = 1;
          }
      } else {
          this.room_data.breakings.push({
            quantity            : 0,
            cod_items_price     : c.cod_items_price,
            distribution_room_id: this.room_data.cod_distribution_room,
            item_id             : c.cod_items,
          });
      }
    }
    this.hk_item_prices_tmp = JSON.parse(JSON.stringify(this.room_data.room.espaco.hk_item_prices));
    this.observation        = this.room_data.observation;
  }
}
</script>
<style>
  .footer {
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>